module.exports = __webpack_public_path__ + "static/media/warning.670eb8f0.svg";